'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _newSchool = require('../../../new-school');

var _newSchool2 = _interopRequireDefault(_newSchool);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TeacherSchoolsController = function () {
  function TeacherSchoolsController($state, fNewSchoolDialog, $scope) {
    _classCallCheck(this, TeacherSchoolsController);

    this._ = { $state: $state, fNewSchoolDialog: fNewSchoolDialog, $scope: $scope };
  }

  _createClass(TeacherSchoolsController, [{
    key: 'editSchool',
    value: function editSchool($event, school) {
      var _this = this;

      this._.fNewSchoolDialog($event, school)
      // update school in scope
      .then(function (s) {
        _this._.$scope.teacherSchools.schools.forEach(function (tschool) {
          if (tschool.school.id == school.id) {
            tschool.school = s.data;
          }
        });
      });
    }
  }]);

  return TeacherSchoolsController;
}();

exports.default = angular.module('ifeis.dashboard-teacher-schools', ['ui.router', 'ifeis.common']).directive('fTeacherSchools', function () {
  return {
    bindToController: true,
    controller: 'TeacherSchoolsController',
    controllerAs: 'teacherSchools',
    scope: {
      schools: '=schools'
    },
    template: require('./tpl.html')
  };
}).controller('TeacherSchoolsController', TeacherSchoolsController);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/teacher-schools/index.js
// module id = 531
// module chunks = 0